var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccionaCluster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "#F5B6B6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5838,
    cy: 23.5838,
    r: 23.5838,
    fill: "#F5B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccionaCluster);
export default __webpack_public_path__ + "static/media/acciona_cluster.61bccf5823d1c4ac09ec6df7b8005448.svg";
export { ForwardRef as ReactComponent };